

<div class="matero-sidebar-main scrollbar-none">
  
  <button style="position: absolute;
  top: 0;
  right: 0;" fxHide="true" fxShow.xs="true" fxShow.sm="true" mat-icon-button class="matero-toolbar-button" (click)="toggleSidenav.emit()">
    <mat-icon style="color: var(--color-client-text);">close</mat-icon>
  </button>

  <app-user-panel *ngIf="showUser"></app-user-panel>
  <app-sidemenu [ripple]="showToggle"></app-sidemenu>
</div>

<!-- <div class="matero-sidebar-header" *ngIf="showHeader">
  <app-branding></app-branding>
  <span fxFlex></span>
  <mat-slide-toggle (change)="toggleCollapsed.emit()" [checked]="toggleChecked" *ngIf="showToggle">
  </mat-slide-toggle>
</div> -->
